import styled from "styled-components"

export const Container = styled.svg`
  width: 30px;
  height: 40px;
  cursor: pointer;
`
Container.defaultProps = {}
